// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewPane_root__35QnQ","iframe":"PreviewPane_iframe__1vo7S"};